import * as React from 'react';
const SvgCaretLeft = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M18.499 19V5.001c0-2.664-3.235-4.007-5.125-2.117l-7 6.993a3.022 3.022 0 0 0 0 4.25l7 6.993c1.888 1.88 5.125.549 5.125-2.12Zm-10-6.999 6.999-7v14l-7-7Z", fill: "currentColor" })));
export default SvgCaretLeft;
